import { useState } from 'react';
import uploadApi from '_api/upload';
import eventApi from '_api/event';

export default function useDetectEventImg() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [detectedData, setDetectedData] = useState(null);

  const handleDetect = async ({ file }) => {
    if (file) {
      setIsSubmitting(true);
      setErrorMessage('');
      setStatusMessage('Uploading image...');
      try {
        const uploadRes = await uploadApi.uploadPhoto([file]);
        const imageUrl = uploadRes?.msgResp?.url || uploadRes?.url;

        if (!imageUrl) {
          throw new Error('Failed to upload image. Please try again.');
        }

        setStatusMessage('Detecting event from image...');
        const detectRes = await eventApi.detectEventFromImage({ imageUrl });

        const data = detectRes?.msgResp || detectRes;
        setDetectedData(data);
        setStatusMessage('Detected successfully!');

        return {
          ...(typeof data === 'object' && data !== null ? data : {}),
          imageUrl,
        };
      } catch (err) {
        console.error('Error detecting event from image:', err);
        setErrorMessage(
          err?.response?.data?.message || err?.message || 'Failed to detect event from image'
        );
        setStatusMessage('');
      } finally {
        setIsSubmitting(false);
      }
      return null;
    }
  };

  const clearMessages = () => {
    setStatusMessage('');
    setErrorMessage('');
    setDetectedData(null);
  };

  return {
    isSubmitting,
    statusMessage,
    errorMessage,
    detectedData,
    setDetectedData,
    handleDetect,
    clearMessages,
  };
}
